<template>
  <div class="content">
    <div class="about">
      <p class="title" :style="{ color: textColor }" id="title">{{ title }}</p>
      <div class="desc" :style="{ color: textColor }">
        <div v-for="(item, index) in desc" :key="index">
          <ul v-if="item.type === 'list'">
            <li v-for="(list, index) in item.text" :key="index">
              {{ index + 1 }}. {{ list }}
            </li>
          </ul>
          <span v-else>{{ item.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      desc: [],
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      const { title, desc } = config.page[1];
      this.title = title;
      this.desc = desc;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 10px 0;
  flex: 1;
  background-image: url("~@/assets/images/about.png");
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  .about {
    // max-width: 960px;
    transform: translateX(36%);
    width: 54%;
    .title {
      font-size: 33px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 46px;
    }
    .desc {
      width: 80%;
      line-height: 24px;
      div {
        margin-bottom: 15px;
      }
      ul {
        margin-top: 10px;
      }
      ul li {
        margin-left: 20px;
        font-size: 18px;
      }
    }
  }
}
</style>
